import { render, staticRenderFns } from "./SKPTahunan.vue?vue&type=template&id=792e8817&scoped=true&"
import script from "./SKPTahunan.vue?vue&type=script&lang=js&"
export * from "./SKPTahunan.vue?vue&type=script&lang=js&"
import style0 from "./SKPTahunan.vue?vue&type=style&index=0&id=792e8817&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792e8817",
  null
  
)

export default component.exports